import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TravellerFieldEnum } from '@websky/graphql';
import { ThemeProvider } from '@websky/core/src/theme';
import { useConfig } from '@websky/core/src/context';
import { NEW_ACCOUNT_NOTIFICATION, getSessionStorage } from '@websky/core/src/cache';
import { getUserValue } from '@websky/core/src/utils';
import { Mail, Person, PhoneSuccess, Takeoff } from '@websky/core/src/Icons';
import CheckoutAdditionalService from '@websky/core/src/CheckoutAdditionalService/CheckoutAdditionalService/CheckoutAdditionalService';
import Button from '@websky/core/src/Button';
import { Notification, Percent } from './icons';
import css from './Account.css';
const Account = ({ userInfo }) => {
    const { t } = useTranslation('Checkout');
    const { Engine: { accountURL } } = useConfig();
    const additionalServiceTheme = {
        CheckoutAdditionalService: {
            CheckoutAdditionalService: {
                header: css.header,
                header__text: css.header__text
            }
        }
    };
    const advantages = new Map([
        [t('Track flights'), Takeoff],
        [t('Get notifications'), Notification],
        [t('Correspond with the airline'), Mail],
        [t('Get discounts'), Percent],
        [t('Add travel companions'), Person],
        [t('Login from any device'), PhoneSuccess]
    ]);
    const email = React.useMemo(() => getUserValue(userInfo.userProfile, TravellerFieldEnum.Email), [userInfo]);
    const renderControls = React.useCallback(({ addClick }) => (React.createElement("div", { className: css.controls },
        React.createElement(Button, { onClick: addClick }, t('Open Personal Account')))), []);
    const goToAccount = () => {
        window.open(accountURL);
    };
    const showNotification = getSessionStorage(NEW_ACCOUNT_NOTIFICATION);
    if (!showNotification) {
        return null;
    }
    return (React.createElement(ThemeProvider, { value: additionalServiceTheme },
        React.createElement(CheckoutAdditionalService, { className: css.service, header: t('Now you have a Personal Account {{email}}', { email }), description: [...advantages.entries()].map(([text, icon], index) => (React.createElement("div", { className: css.advantage, key: index },
                React.createElement("div", { className: css.advantage__icon }, icon),
                text))), renderControls: renderControls, addClick: goToAccount, isSelected: false })));
};
export default Account;
